import React from 'react';
import { ClientUsersPage } from './ClientUsersPage';
import { IClientUserData } from '../../types/clients';
import {
  useListClientUsersQuery,
  useAddClientUserMutation,
  useEditClientContactsMutation,
} from '../../API/clients/ClientUsersApi';
import { convertToError } from '../../API/BaseApi';

export const ClientUsersContainer: React.FC<{ clientId: string }> = ({ clientId }) => {
  const { data: clientContacts = [], error: pageError, isFetching, isSuccess } = useListClientUsersQuery(clientId);
  const [addClientUser, addResult] = useAddClientUserMutation();
  const [editClientUser, editResult] = useEditClientContactsMutation();

  const onAddNewContact = async (contact: IClientUserData) => {
    await addClientUser({ clientId, contact });
  };
  const onResetAdd = () => addResult.reset();

  const onEditContact = async (contact: IClientUserData) => {
    await editClientUser({ clientId, contact });
  };
  const onResetEdit = () => editResult.reset();

  return (
    <ClientUsersPage
      clientCompanyId={clientId}
      pageError={convertToError(pageError)}
      clientContacts={clientContacts}
      onAddContact={onAddNewContact}
      onAddContactReset={onResetAdd}
      getContactFetchStatus={{
        fetching: isFetching,
        fetched: isSuccess || !!pageError,
        success: isSuccess,
      }}
      addContactFetchStatus={{
        fetching: addResult.isLoading,
        fetched: addResult.isSuccess || addResult.isError,
        success: addResult.isSuccess,
      }}
      addContactError={convertToError(addResult.error)}
      onEditContact={onEditContact}
      onEditContactReset={onResetEdit}
      editContactFetchStatus={{
        fetching: editResult.isLoading,
        fetched: editResult.isSuccess || editResult.isError,
        success: editResult.isSuccess,
      }}
      editContactError={convertToError(editResult.error)}
    />
  );
};
